import { css, html, LitElement } from "lit"

export default class PageNews extends LitElement {
  static properties = {
    news: { type: Array },
    enCoursDeChargement: { type: Boolean },
  }

  static styles = css`
        .zone-news {
            display: flex;
            flex-wrap: wrap;
            gap: 20px;
        }

        .zone-news article {
            border: 1px solid var(--couleur-texte);
            padding: 10px;
            width: 400px;
        }

        .zone-news img {
            width: 400px;
            height: auto;
        }

        @media (max-width: 768px) {
            .zone-news article {
                width: 100%;
            }

            .zone-news img {
                width: 100%;
            }
        }

        .spinner {
          width: 3rem;
          height: 3rem;
          border: 4px solid var(--couleur-300);
          border-top: 4px solid var(--couleur-600);
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 2rem auto;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
    `

  async connectedCallback() {
    super.connectedCallback()
    this.enCoursDeChargement = true
    try {
      const response = await fetch("/.netlify/functions/recupererNews")
      this.news = await response.json()
    } catch (error) {
      console.error("Erreur lors de la récupération des news :", error)
    } finally {
      this.enCoursDeChargement = false
    }
  }

  render() {
    return html`
            <h1>Dernières news de Pokémon Go</h1>
            ${this.enCoursDeChargement ? html`<div class="spinner"></div>` : this.genererNews()}
        `
  }

  genererNews() {
    if (!this.news || this.news.length === 0) {
      return html`<p>Aucune news disponible pour le moment.</p>`
    }
    return html`
            <div class="zone-news">
                ${this.news?.map(
                  (news) => html`
                        <article>
                            <img src="${news.image}" alt="${news.title}">
                            <h2>${news.title}</h2>
                            <p>${news.date}</p>
                            <a href="${news.link}" target="_blank">Lire la suite</a>
                        </article>
                    `,
                )}
            </div>
        `
  }
}
customElements.define("p-page-news", PageNews)
